/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { BrowseSearchMetadata }
from '@thd-olt-component-react/metadata';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { SponsoredBannerComposable }
from '@thd-olt-component-react/sponsored-content';

import {
  PLPResultsHeader, ResultsAppliedComposable, ResultsFilterAndSortDrawerComposable, ResultsDimensionsComposable, ResultsSortByComposable, ResultsToggleLayoutComposable, ResultsPaginationComposable
}
from '@thd-olt-component-react/product-results';

import { HybridContentfulWidgetComposable }
from '@thd-olt-component-react/hybrid';

import { ProductCategoryVisnavComposable }
from '@thd-olt-component-react/product-category-visnav';

import { PLPRecsComposable, PlpRvRenderPlaceholder }
from '@thd-olt-component-react/thd-recs-containers';

import { DefaultGridComposable }
from '@thd-olt-component-react/plp-grid';

import { SearchFeedback }
from '@thd-olt-component-react/search-feedback';

import { RetailMediaCarouselFusionComposable }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { BrowseSearchRedirector }
from '@thd-nucleus/app-render';

import { TempDatasourcesHackForFusionDataModels }
from '@thd-olt-component-react/temp-datasources-hack-for-fusion-dataModels';

export { BrowseSearchMetadata };

export { Breadcrumbs };

export { SponsoredBannerComposable };

export { PLPResultsHeader };

export { HybridContentfulWidgetComposable };

export { ProductCategoryVisnavComposable };

export { PLPRecsComposable };

export { ResultsAppliedComposable };

export { ResultsFilterAndSortDrawerComposable };

export { ResultsDimensionsComposable };

export { ResultsSortByComposable };

export { ResultsToggleLayoutComposable };

export { DefaultGridComposable };

export { ResultsPaginationComposable };

export { SearchFeedback };

export { RetailMediaCarouselFusionComposable };

export { PlpRvRenderPlaceholder };

export { BrowseSearchRedirector };

export { TempDatasourcesHackForFusionDataModels };

const SlotA1 = withLayout(
  [

    BrowseSearchMetadata,

  ],

);

const SlotA2 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotB1 = withLayout(
  [

    SponsoredBannerComposable,

  ],

);

const SlotB2 = withLayout(
  [

    PLPResultsHeader,

  ],

);

const SlotB3 = withLayout(
  [

    HybridContentfulWidgetComposable,

  ],

);

const SlotB4 = withLayout(
  [

    ProductCategoryVisnavComposable,

  ],

);

const SlotC1 = withLayout(
  [

    PLPRecsComposable,

  ],

);

const SlotD1 = withLayout(
  [

    ResultsAppliedComposable,

  ],

);

const SlotD2 = withLayout(
  [

    ResultsFilterAndSortDrawerComposable,

  ],

);

const SlotE1 = withLayout(
  [

    ResultsDimensionsComposable,

  ],

);

const SlotF1 = withLayout(
  [

    ResultsSortByComposable,

  ],

);

const SlotF2 = withLayout(
  [

    ResultsToggleLayoutComposable,

  ],

);

const SlotG1 = withLayout(
  [

    ResultsAppliedComposable,

  ],

);

const SlotH1 = withLayout(
  [

    DefaultGridComposable,

  ],

);

const SlotH2 = withLayout(
  [

    ResultsPaginationComposable,

  ],

);

const SlotH3 = withLayout(
  [

    SearchFeedback,

  ],

);

const SlotI1 = withLayout(
  [

    PLPRecsComposable,

  ],

);

const SlotI2 = withLayout(
  [

    RetailMediaCarouselFusionComposable,

  ],

);

const SlotI3 = withLayout(
  [

    PlpRvRenderPlaceholder,

  ],

);

const SlotJ1 = withLayout(
  [

    BrowseSearchRedirector,

  ],

);

const SlotJ2 = withLayout(
  [

    TempDatasourcesHackForFusionDataModels,

  ],

);

const ssr = typeof window === 'undefined';

export {

  SlotA1,

  SlotA2,

  SlotB1,

  SlotB2,

  SlotB3,

  SlotB4,

  SlotC1,

  SlotD1,

  SlotD2,

  SlotE1,

  SlotF1,

  SlotF2,

  SlotG1,

  SlotH1,

  SlotH2,

  SlotH3,

  SlotI1,

  SlotI2,

  SlotI3,

  SlotJ1,

  SlotJ2,

};
